import { render, staticRenderFns } from "./BrushTopic.vue?vue&type=template&id=28d676a4&scoped=true&"
import script from "./BrushTopic.vue?vue&type=script&lang=js&"
export * from "./BrushTopic.vue?vue&type=script&lang=js&"
import style0 from "./BrushTopic.vue?vue&type=style&index=0&id=28d676a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d676a4",
  null
  
)

export default component.exports